import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import './Footer.scss';
import '../Field/Field.scss';
import Button from "../Button/Button";
import { newLetterSubscription } from "../../services/api";
import { getQueryParam } from "../../services/shared";
import sparksDesktop from "../../assets/images/footersparksDesktop.png";
import sparksMobile from "../../assets/images/footermobilesparks.png";

const Footer = ({className, baseUrl = '/'})=>{


    const params = new URLSearchParams(window.location.search);

    const { register, handleSubmit, watch, errors, reset } = useForm();
    const [hasSubmitted, setHasSubmitted] = useState(false)
    const [isSubscribing , setIsSubscribing] = useState(false);
    const [hideLink , setHideLink ] = useState(false); //Hide Links used for hide elements on t2 - /deals_ae URL
    const [tmpl, setTmpl] = useState('')

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        setTmpl(urlParams.get('tmpl'))
    }, [])

    //Hide Links used for hide elements on t2 - /deals_ae URL
    useEffect(()=> {
          window.location.pathname === '/deals_ae' ? setHideLink(true) : setHideLink(false)
    },[])

    return(<footer className={`main-footer ${className}`} >
        <div className="footer-content-container container flex" >
            <div className="flex-1 section-margin">
                <div className="brand-name">Get Car Deals</div>
                <div>Buying a car? Get the best deals from your local dealers easily.</div>
            </div>
            <div className={`flex-1 section-margin ${params.get('utm_source')?.toLowerCase() === "ae" ? ' remove-margin-bottom' : ''} `}>
                <div className="bold font-white">Pages</div>
                <ul className="footer-link-list">
                    {   params.get("utm_source")?.toLowerCase() !== 'ae' ?
                        (!hideLink && <> 
                            <li><a href={`${baseUrl}?${getQueryParam(params)}`}>Home</a></li>
                            <li><a href={`/blog?${getQueryParam(params)}`}>Blog</a></li>
                        </>) : <></>
                    }
                    <li><a href={`/privacy-policy?${getQueryParam(params)}`}>Privacy Policy</a></li>
                   {!hideLink && <li><a href={`/about?${getQueryParam(params)}`}>About Us</a></li>}
                    {params.get('utm_source')?.toLowerCase() !== "ae" && <li><a href={`/contact?${getQueryParam(params)}`}>Contact Us</a></li>}
                    <li><a href={`/dsmi?${getQueryParam(params)}`}>Do Not Sell or Share My Personal Information</a></li>
                </ul>
            </div>
            {
                params.get('utm_source')?.toLowerCase() !== "ae" && 
                <div className="flex-1 subscription-wrapper">
                    <div className="subscription-text">Subscribe to our newsletters.</div>
                    <form onSubmit={handleSubmit((data)=>{
                        window.dataLayer?.push({
                            'event': 'Email Subscribed'
                        })
                        setIsSubscribing(true);
                        setHasSubmitted(false);
                        newLetterSubscription({
                            email: data.email
                        }).then(_=>{
                            reset()
                            setHasSubmitted(true);
                            setIsSubscribing(false);
                        })
                    },()=>{
                        setHasSubmitted(false);
                    })}>
                        <div className={`field has-floating-button no-margin ${errors.email?'error':''}`}>
                            <div className="relative">
                                <input name="email" maxLength="50" type="text" ref={register({ required: true, pattern: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i })} value={watch("email")} onBlur={()=>{
                                    window.dataLayer?.push({
                                        'event': 'Entered Subscription email'
                                    })
                                }}
                                aria-label="Email"
                                />
                                <label for="email">Email</label>
                                <Button loading={isSubscribing} type="submit" className="floating-button">Subscribe</Button>
                            </div>
                            {
                                errors.email &&
                                <div className="error-msg">Please enter a valid email.</div>
                            }
                        </div>
                        {
                            hasSubmitted &&
                            <div className="success-message">You have subscribed successfully</div>
                        }
                    </form>
                </div>
            }
            
        </div>
        <div className="copy-right-container container flex justify-center">
            <div>Copyright &copy; {new Date().getFullYear()} Get Car Deals. All rights reserved.</div>

        </div>
    </footer>)
}
export default Footer;